var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ItpIcon", {
    attrs: {
      title: _vm.$config.meterTypes[_vm.type].description,
      name: _vm.$config.meterTypes[_vm.type].icon,
      color: _vm.color
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }